import { SliderWithTitle } from '@hivebrite/design-system/Slider';
import { useBreakpoint } from '@hivebrite/design-system/Theme';

import type { SliderLayoutsProps } from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderLayouts';
import type { Post } from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderLayouts/PostsWrapper/types';
import { SLIDER_TYPES } from 'hb-builder/components/BuilderComponents/dynamic/Slider/SliderLayouts/types';
import { perPageBreakpoints } from 'hb-builder/components/BuilderComponents/dynamic/Slider/utils/breakpoints';
import { getHeadline } from 'hb-builder/components/BuilderComponents/dynamic/Slider/utils/getHeadline';
import Grid from 'hb-react/shared/components/DesignSystem/Grid';
import { APP_TYPE } from 'hb-react/types/appType';

import LoadingItem from './LoadingItem';
import { mapPosts } from './mapData';
import PostItem from './PostItem';

type PostsProps = Pick<SliderLayoutsProps, 'app' | 'item' | 'ids'> & {
  isLoading: boolean;
  data: Post[];
};

const Posts = ({ app, item, isLoading, data: posts, ids }: PostsProps) => {
  const topicId = ids?.topic;
  const breakpoint = useBreakpoint();
  const title = getHeadline(item, SLIDER_TYPES.POSTS);
  const linkText =
    breakpoint !== 's' ? s__('Builder|See all posts') : s__('Builder|See all');
  const sliderLink =
    app === APP_TYPE.BACKOFFICE
      ? { text: linkText, url: '#', target: '' }
      : {
          text: linkText,
          url: topicId ? Routes.topic_feed_path(topicId) : Routes.feed_path(),
          target: '_self',
        };

  if (!posts) {
    return null;
  }

  return (
    <Grid width="100%" mx={0} my={4}>
      <SliderWithTitle
        title={title}
        link={sliderLink}
        perPageBreakpoints={perPageBreakpoints[SLIDER_TYPES.POSTS]}
        items={mapPosts({ app, posts, topicId })}
        ItemComponent={PostItem}
        total={posts.length}
        loading={isLoading}
        LoadingItemComponent={LoadingItem}
      />
    </Grid>
  );
};

export default Posts;
